// Constant data for Inventory

export const PRODUCT_STATUS = {
  ENABLED  : 'enabled',
  DISABLED : 'disabled'
}

export const INVENTORY_TYPE = {
  SELLER_PRODUCT           : 'Seller::Product',
  MERCHANT_PRODUCT_VARIANT : 'Merchant::Product::Variant'
}

export const MOVEMENT_ACTION = {
  MIGRATE_OLD_DATA     : 'migrate_old_data',
  PUT_AWAY             : 'put_away',
  RETURN_TO_VENDOR     : 'return_to_vendor',
  REQUEST              : 'request',
  REQUEST_RETURN       : 'request_return',
  ORDER                : 'order',
  ORDER_EXPIRE         : 'order_expire',
  ORDER_SHIPMENT       : 'order_shipment',
  REFUND               : 'refund',
  MOVE_IN              : 'move_in',
  MOVE_OUT             : 'move_out',
  MANUALLY_ADD_ITEM    : 'manually_add_item',
  MANUALLY_REMOVE_ITEM : 'manually_remove_item'
}

export const PROCESS_TYPE = {
  SELLER_INVENTORY_BATCH   : 'Seller::Inbound::InventoryBatch',
  MERCHANT_INVENTORY_BATCH : 'Merchant::Inbound::InventoryBatch',
  SELLER_OUTBOUND_RETURN   : 'Seller::Outbound::Return',
  MERCHANT_OUTBOUND_RETURN : 'Merchant::Outbound::Return',
  INTERNAL_REQUEST         : 'Admin::Outbound::InternalRequest',
  ORDER                    : 'Customer::Order',
  SHIPMENT                 : 'Customer::Shipment',
  REFUND                   : 'Customer::Refund'
}
